import { PARTNER_REPORT_FILE_EXTENSION } from 'redux/reducers/referrals/constants';
import { TPartnersRow, TPartnerReport } from 'redux/reducers/referrals/types';
import { TTableStructure, TTableStructureFilter } from 'ui/EasTable/types';
import { FIRST_REPORT_YEAR, MONTHS, PARTNER_FILTER_SELECTOR } from './constants';

/** "2025-06", the period a report covers. */
export const formatReportPeriod = (report: Pick<TPartnerReport, 'year' | 'month'>): string =>
	`${report.year}-${String(report.month).padStart(2, '0')}`;

/** "June 2025". */
export const formatReportPeriodName = (report: Pick<TPartnerReport, 'year' | 'month'>): string =>
	`${MONTHS[report.month - 1] ?? report.month} ${report.year}`;

export const getPartnerReportFileName = (report: TPartnerReport): string => {
	const baseName =
		`fees_report_${report.partnerName ?? report.partnerId}_${formatReportPeriod(report)}`
			.replace(/[^\w.-]+/g, '_')
			.replace(/_+/g, '_');
	return `${baseName}.${PARTNER_REPORT_FILE_EXTENSION}`;
};

/** Years from the current one down to the first year with reports. */
export const getYearOptions = (currentYear = new Date().getFullYear()): TTableStructureFilter => {
	const options: TTableStructureFilter = [];
	for (let year = Math.max(currentYear, FIRST_REPORT_YEAR); year >= FIRST_REPORT_YEAR; year -= 1) {
		options.push([String(year), String(year)]);
	}
	return options;
};

/** The Partner column offers the partners the API knows about, the Year column the years with reports. */
export const withFilterOptions = (
	structure: TTableStructure<keyof TPartnerReport, TPartnerReport>[],
	partners: Pick<TPartnersRow, 'id' | 'partnerName'>[],
): TTableStructure<keyof TPartnerReport, TPartnerReport>[] => {
	const partnerOptions: TTableStructureFilter = partners.map((partner): [string, string] => [
		String(partner.id),
		partner.partnerName,
	]);
	const yearOptions = getYearOptions();

	return structure.map((column) => {
		if (column.selector === PARTNER_FILTER_SELECTOR) return { ...column, filter: partnerOptions };
		if (column.selector === 'year') return { ...column, filter: yearOptions };
		return column;
	});
};
